import storage from './storage'

/**
 * @descibe 解析url参数
 * @parma null
 */
export const getQuery = (str?: any) => {
  let searchParams: any = window.location.search
    ? window.location.search.substring(1)
    : '';
  searchParams = searchParams.split('&');
  const queryBody =
    Array.isArray(searchParams) &&
    searchParams.reduce((res, item) => {
      const queryGroup = item.split('=');
      if (queryGroup.length === 2) {
        res[queryGroup[0]] = queryGroup[1];
      }
      return res;
    }, {});
  return queryBody;
};

/*
 * @descibe 解析url参数
 * @parma null
 */
export const requestCacheWrapper = (getFn: any, tag?: any, day?: number) => {
  let tagStr = Array.isArray(tag) ? tag.join('-') : tag
  const saveCacheFn = (data: any) => {
    if (tag) {
      storage.local.set(tagStr, JSON.stringify(data))
    }
    if (day && !isNaN(day) && day > 0) {
      // const currentTime = new Date().getTime() 
      // const expiresDate = currentTime + (1000 * 60 * 60) * saveHour
      storage.cookie.set(tagStr, 1, day)
    }
  }
  let res = {}
  if (tag) {
    const localCacheStr = storage.local.get(tagStr)
    const cookieTag: any = storage.cookie.get(tagStr)
    if (localCacheStr !== null && cookieTag == 1) {
      try {
        res = JSON.parse(localCacheStr)
      } catch (error) {
        res = getFn(saveCacheFn)
      }
      return res
    }
  }
  res = getFn(saveCacheFn)
  return res
};